import { isPoint, toPoint } from '../../utils';
export var get = function (object, path) {
    var index = 0;
    var length = path.length;
    while (!!object && index < length) {
        object = object[path[index++]];
    }
    return (index && index === length) ? object : undefined;
};
var clone = function (obj, index) {
    if (!obj) {
        return typeof index === 'number'
            ? Array.from(Array(index))
            : {};
    }
    return Array.isArray(obj)
        ? obj.concat()
        : Object.assign({}, obj);
};
var mutableAssign = function (obj, index, val) {
    obj[index] = val;
    return obj;
};
export var set = function (obj, path, val) {
    if (get(obj, path) === val) {
        return obj;
    }
    var index = path[0];
    var copy = clone(obj, index);
    if (path.length === 1) {
        return mutableAssign(copy, index, val);
    }
    return mutableAssign(copy, index, set(copy[index], path.slice(1), val));
};
export var memoize = function (fn, compare) {
    var cache;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var nextCache = fn.apply(void 0, args);
        if (compare(cache, nextCache)) {
            return cache;
        }
        cache = nextCache;
        return cache;
    };
};
export var comparePoint = function (prev, next) {
    if (prev && next) {
        var prevLat = prev[0], prevLon = prev[1];
        var nextLat = next[0], nextLon = next[1];
        return prevLat === nextLat && prevLon === nextLon;
    }
    return false;
};
export var comparePoints = function (prev, next) {
    if (prev && next && prev.length === next.length) {
        for (var i = 0, len = prev.length; i < len; i += 1) {
            if (!comparePoint(prev[i], next[i])) {
                return false;
            }
        }
        return true;
    }
    return false;
};
export var memoPoints = memoize(function (route) {
    var points = route.map(function (routePoint) {
        var _a;
        var address = routePoint === null || routePoint === void 0 ? void 0 : routePoint.address;
        var point = address && address.isValid ? toPoint((_a = address.geoObject) === null || _a === void 0 ? void 0 : _a.pos) : undefined;
        if (point) {
            return point;
        }
        return undefined;
    });
    if (isPoint(points[0])) {
        return points.filter(isPoint);
    }
}, comparePoints);
export var createAction = function (type) { return function (payload) { return ({
    type: type,
    payload: payload,
}); }; };
export function createTimeoutCache(timeout) {
    return function setCache(callback) {
        var timer = window.setTimeout(function () {
            callback();
            timer = undefined;
        }, timeout);
        return function clearCache() {
            if (timer !== undefined) {
                clearTimeout(timer);
                timer = undefined;
            }
        };
    };
}
